<template>
  <div class="w-100 my-5">
    <div class="my-5">
      <span class="font-15 font-bold">Attack List: {{ attackList.length }}</span>
    </div>
    <div class="my-5" v-if="(attackList.length > 0)">
      <div class="d-flex flex-column" v-for="(item, index) in attackList" :key="(item, index)">
        <div class="col-sm-12">
          <v-card class="my-2 box-white d-flex flex-column">
            <div class="m-2 row">
              <span class="col-sm">{{ item.uid === 'UwhNHEeuwZVXyeaF46j9TyGKN5l2' ? 'Guest' : item.uid }}</span>
              <span class="col-sm">{{ item.fieldPath }}</span>
              <span class="col-sm">{{ item.value }}</span>
              <span class="col-sm">{{ getDateStringFromTimestamp(item.createdAt) }}</span>
              <v-btn class="ml-auto" icon small @click="deleteAttackInfoTask(item.id)" v-if="userList.filter(element => element.userName === item.value || element.email === item.value.toLowerCase()).length > 0">
                <i class="flaticon-delete color-red"></i>
              </v-btn>
              <v-btn class="mx-5" icon small @click="getUserListTask(item.value)">
                <i class="flaticon-info color-blue"></i>
              </v-btn>
            </div>
          </v-card>
        </div>
        <span class="color-blue">{{ getUserInfo(item.value) }}</span>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <span class="font-20 alpha-07">{{ $t('no_data_found') }}</span>
    </div>
  </div>
</template>

<script>
import { httpsCallable } from 'firebase/functions';
import { functions, firestore } from '../../../main';
import { collection, query, or, where, getDocs } from 'firebase/firestore';
import { getDateStringFromTimestamp, showLoading } from '../../../functions';

export default {
  name: 'AttackLink',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    attackList() {
      return this.$store.state.attackList;
    }
  },
  data() {
    return {
      userList: [],
    }
  },
  mounted() {
    if (window.location.hostname !== 'localhost') {
      this.$router.push('/');
    }
  },
  methods: {
    getDateStringFromTimestamp,
    getUserInfo(value) {
      const userInfo = this.userList.find(element => element.email === value.toLowerCase());
      if (userInfo) {
        return `userId: [${userInfo.userId}], userName: [${userInfo.userName}], email: [${userInfo.email}], userType: [${userInfo.userType}] deviceType: [${userInfo.deviceType}], createdAt: [${getDateStringFromTimestamp(userInfo.createdAt)}], updatedAt: [${getDateStringFromTimestamp(userInfo.updatedAt)}], lastOnlineAt: [${getDateStringFromTimestamp(userInfo.lastOnlineAt)}]`
      } else {
        return '';
      }
    },
    getUserListTask(value) {
      const loader = showLoading(this, 1);
      const q = query(collection(firestore, 'user'), or(where('email', '==', value.toLowerCase()), where('userName', '==', value)));
      getDocs(q).then(querySnapshot => {
        loader.hide();
        const list = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          list.push(data);
          if (!this.userList.find(element => element.email === data.email)) {
            this.userList.push(data);
          }
        });
        if (list.length === 0) {
          this.$toast.info(`No user found with [${value}]`);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error('Unexpected error occurs - ' + error.message);
      });
    },
    deleteAttackInfoTask(id) {
      const params = {
        functionName: 'deleteAttackInfo',
        id: id
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>